import { render, staticRenderFns } from "./PriceSourceCreate.vue?vue&type=template&id=fc3ae35a"
import script from "./PriceSourceCreate.vue?vue&type=script&lang=js"
export * from "./PriceSourceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports